module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm White Ceramic + White Open.7d463c35.png";